const doc = [({"zh_cn":({"adminLabelHotelCalendar":({"endDate":"结束日期", "hotelSpecifiedStaysOnlyPeriods":"住宿晚数有限", "period":"时期", "startDate":"开始日期", "stays":"入住晚数"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;